import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../../../components/Modal/index.jsx';
import MLButton from '../../../../../components/MLButton/MLButton.jsx';
import styles from './GRSAIEnableModal.module.css';

const GRSAIEnableModal = ({ open, enableAiSummaries, onCancel }) => {
  return (
    <Modal
      open={open}
      onClosed={onCancel}
      closeIconTestId="Insights_grs_summaries_close_modal_x_btn"
    >
      <Modal.Header data-test-id="Insights_grs_summaries_enable_modal_header">
        Enable Summaries for GRS Responses
      </Modal.Header>
      <Modal.Content
        data-test-id="Insights_grs_summaries_enable_modal_text"
        className={styles.enableAiContent}
      >
        Achieve can provide a summary of student responses for the standard
        open-ended questions in the Goal-setting and Reflection Surveys (GRS),
        providing you with valuable overviews into the top themes and trends
        from students. The summaries will be available within 24 hours of the
        assignment’s main due date. You can access the summaries by selecting
        the “View Responses” button on any GRS Insight card that is marked as
        having a summary available. You can also disable this feature at any
        time.
        <br />
        By enabling the Summaries for GRS Responses, you acknowledge this
        feature uses AI technology. Your use of this feature is governed by our{' '}
        <a
          href="https://store.macmillanlearning.com/us/termsOfUse?_ga=2.55646188.615888239.1586735215-428872584.1578955260"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Use
        </a>{' '}
        and{' '}
        <a
          href="https://store.macmillanlearning.com/us/privacy-notice"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
        . You can learn more in the{' '}
        <a
          href="https://www.macmillanlearning.com/college/us/legal/ai-transparency-statement"
          target="_blank"
          rel="noopener noreferrer"
        >
          AI Transparency Statement
        </a>{' '}
        and by selecting the information icon on this modal.
      </Modal.Content>
      <Modal.Footer>
        <MLButton
          btnType="secondary"
          testId="Insights_grs_summaries_cancel_btn_enable_modal"
          btnText="Cancel"
          onClick={onCancel}
        />
        <MLButton
          btnType="primary"
          testId="Insights_grs_summaries_confirm_btn_enable_modal"
          btnText="Enable Summaries"
          onClick={enableAiSummaries}
        />
      </Modal.Footer>
    </Modal>
  );
};

GRSAIEnableModal.propTypes = {
  open: PropTypes.bool.isRequired,
  enableAiSummaries: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default GRSAIEnableModal;
